import { getHostAPIUrl } from 'appConfig';
import axios from 'axios';

export const getRequestWeb = async (endpoint) => {
  const Axios = axios.create({
    baseURL: getHostAPIUrl(),
    timeout: 30000,
    responseType: 'json',
  });

  const data = Axios.get(endpoint);
  return data;
};
